import { KeyCloakConfig, KeycloakProvider } from '../../providers/keycloak/keycloak.provider';

const config: KeyCloakConfig = {
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT || "",
  realm: process.env.VUE_APP_KEYCLOAK_REALM || "",
  url: process.env.VUE_APP_KEYCLOAK_PATH || "",
};

const configB2C: KeyCloakConfig = {
  clientId: process.env.VUE_APP_KEYCLOAK_B2C_CLIENT || "",
  realm: process.env.VUE_APP_KEYCLOAK_REALM || "",
  url: process.env.VUE_APP_KEYCLOAK_PATH || "",
};

const configB2B: KeyCloakConfig = {
  clientId: process.env.VUE_APP_KEYCLOAK_B2B_CLIENT || "",
  realm: process.env.VUE_APP_KEYCLOAK_B2B_REALM || "",
  url: process.env.VUE_APP_KEYCLOAK_B2B_PATH || "",
};

export const keycloak = new KeycloakProvider(config);
export const keycloakB2C = new KeycloakProvider(configB2C);
export const keycloakB2B = new KeycloakProvider(configB2B);
